import { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import Storage from '../../../session/storage';
import Autocomplete from '@mui/material/Autocomplete';
import CONSTANT from '../../../Constant/Constant';
import { sortTranslated } from '../../shared/util';
import profileData from '../../../config/ProfileDetailsData.json';

const InputDetail = (props) => {
    const [value, setValue] = useState(props.value || null)
    const [lengthFlag, setFlag] = useState();
    const [label, setLabel] = useState(props.label);
    const sourceData  = profileData

    /**
     * map name to key
     * @param {*} name name of attribute
     * @returns key name of attribute
     */
    const getOptionKey = (name) => {
        switch (name) {
            case 'Classification Code':
                return 'Classification';
            case 'Sub Classification Code':
                return 'SubClassification';
            case 'Prefix':
                return 'Title';
            case 'Other Specialty':
                return 'Specialty';
            case 'Primary Specialty':
                return 'Specialty'
            case 'Specialty Type':
                return 'SpecialtyType';
            case 'Identifiers Type':
                return 'AltIDType';
            case 'Identifiers Sub Type':
                return 'AltIDSubtype';  
            case 'State Province':
                return 'StateProvince';    
            case 'Country':
                return 'Country';     
            case 'Country Code':
                return 'Country'
            default:
                return name;

                
        }
    }

    /**
     * Map name to ID
     * @param {*} name 
     * @returns ID of atrribute
     */
    const getId = (name) => {
        switch (name) {
            case 'Classification Code':
                return 'ClassificationCode';
            case 'Sub Classification Code':
                return 'SubClassificationCode';
            case 'Suffix Name':
                return 'SuffixName';
            case 'Middle Name':
                return 'MiddleName';
            case 'Primary Specialty':
                return 'PrimarySpecialty';
            case 'Other Specialty':
                return 'OtherSpecialty';
            case 'State Province':
                return 'StateProvince';
            case 'Identifiers Type':
                return 'Type';
            case 'Identifiers Sub Type':
                return 'SubType'; 

            default:
                return name;
        }
    }

    
    let options = (sourceData.OPEN_DATA_SOURCES.includes(props.sourceName)  ? CONSTANT.LOV_BOUNDED_OPTION_SPCIAL_CASE.includes(getId(label.trim())) :  CONSTANT.LOV_BOUNDED_OPTION.includes(getId(label.trim()))) ? Storage.getLovBoundedList() : Storage.getPickList();
    options = CONSTANT.FORCED_OPTION.includes(label.trim()) ? { [props.entity] :{[label.trim()]: CONSTANT.FORCED_OPTION_VALUE[label.trim()] }} : options;
    
    
    const [required, setRequired] = useState();
    let option = options[props.entity][getOptionKey(label.trim())];
    if(props.sourceName !== undefined && sourceData.OPEN_DATA_SOURCES.includes(props.sourceName)){
            option = CONSTANT.STASTIC_ATTRIBUTE_HCO_exclusion.includes(label.trim()) ? undefined :options?.[props.entity][getOptionKey(label?.trim())]
        }else{
            option = CONSTANT.STASTIC_ATTRIBUTE_HCO.includes(label.trim()) ? undefined :options?.[props.entity][getOptionKey(label?.trim())]
        }
    /**
     * Pass value to parent
     * @param {*} event 
     */
    const passToParent = async (event) => {
        setFlag(event.target.value === null || (event.target.value !== null && event.target.value.length === 0));
        await setValue(event.target.value)
        props.updatedValue({ value: event.target.value === null ? '' : event.target.value }, required && (event.target.value === null || (event.target.value !== null && event.target.value.length === 0)))
    }

    /**
     * Handel Input Change
     * @param {*} event : event
     * @param {*} passTo : parent flag
     * @param {*} reqFlag : validation flag
     */
    const handelInput = (event, passTo, reqFlag) => {
        setFlag(event.target.value === null || (event.target.value !== null && event.target.value.length === 0))
        setValue(event.target.value)

        if (passTo) {
            passToParent(event)
        }
    }

    useEffect(()=>{
        setValue(props.value)
    },[props.value])

    useEffect(()=>{
        setLabel(props.label)
    },[props.label])

    useEffect(() => {
        let flag = (value === null) || (value !== null && value !== undefined && value.length === 0);
        flag = (props.error && flag)
        setFlag(flag);
        setRequired(props.newHCP !== undefined ? CONSTANT.REQUIRED_HCP.includes(label.trim()) : !CONSTANT.OPTIONAL.includes(getId(label.trim())))
        if (props.clear && option === undefined) {
            setValue('')
        } else if (props.clear && option !== undefined) {
            setValue(null)
        }
    }, [props.clear, option, props.error, value, label, props.newHCP])

    return (
        <>
            { 
           
               props.date === false && option !== undefined && !['Country Code', 'Active Flag', 'Country', 'Status', 'State Province'].includes(label) &&
                <Autocomplete
                    value={(label.trim() === 'Other Specialty' && value === null) ? [] : value}
                    key={label}                    
                    onChange={(event, value) => 
                        handelInput({
                          target: { 
                            value: value?.split('//')[0].length > 0 
                                ? value.split('//')[0] 
                                : value 
                          }
                        }, true)}
                    options={option.flatMap(group => sortTranslated(group.options))}          
                    isOptionEqualToValue={(option, value) => option === value}
                    getOptionLabel={(option) => option.split('//')[0]}
                    groupBy={(option) => {return option.includes('//UnClassified') ? 'Unclassified' : `${props.entity} - ${label}` }}
                    id={label}
                    name={label}
                    multiple={label.trim() === 'Other Specialty'}
                    renderInput={(params) =>
                        <TextField {...params} error={(lengthFlag) && required}
                            variant="standard"  
                            id="varantOptionTxT"                    
                            helperText={((lengthFlag) && required) ? "Please Select One Option" : " "} />}
                    />
            }
            { 
           
                props.date === false && option !== undefined && ['Country Code', 'Active Flag', 'Country', 'Status', 'State Province'].includes(label) &&
                <Autocomplete
                    value={(label.trim() === 'Other Specialty' && value === null) ? [] : option.find(opt => opt.split(' | ')[opt.split(' | ').length-1]?.trim() === value) || null}
                    key={label}                    
                    onChange={(event, value) => handelInput({ target: { value: value ? value.split(' | ')[value.split(' | ').length - 1]?.trim() : ''} }, true)}
                    options={sortTranslated(option)}
                    getOptionLabel={(option) => option.split(' | ')[0]?.trim()}
                    isOptionEqualToValue={(option, value) => option.split(' | ')[0]?.trim() === value.split(' | ')[value.split(' | ').length -1]?.trim()}
                    id={label}
                    name={label}
                    multiple={label.trim() === 'Other Specialty'}
                    renderInput={(params) =>
                        <TextField {...params} error={(lengthFlag) && required}
                            variant="standard"  
                            id="varantOptionTxT"                    
                            helperText={((lengthFlag) && required) ? "Please Select One Option" : " "} />}
                    />
            }
            {
                props.date === true && props.type !== 'number' && option === undefined && label != 'Classification Code' && 
                <TextField
                    value={value || ''}
                    id={label}
                    variant="standard"
                    name={label}
                    onChange={handelInput}
                    error={(lengthFlag) && required}
                    helperText={(lengthFlag && required)  ? <span id="input-text">Please Enter Something</span> : " "}
                    onBlur={passToParent}
                    className="w-100"
                    type="date"
                    inputProps={{ max: "9999-12-31" }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            }
            {
                props.date === false && option === undefined && label != 'Classification Code' && 
                < TextField
                    type={props.type}
                    key={label}
                    variant="standard"
                    error={((lengthFlag) && required)}
                    helperText={(lengthFlag && required)  ? <span id="input-text">Please Enter Something</span> : " "}
                    value={(value || '')}
                    onChange={handelInput}
                    onBlur={passToParent}
                    id={label}
                    name={label}
                    color="primary" className="w-100 input-text" />
            }
        </>
    )

}

export default InputDetail;